import React from 'react';
import { Divider, Popconfirm, Badge } from 'antd';

export default (self, s) => [
  {
    title: '插件名',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '插件文件',
    dataIndex: 'plugin_file',
    key: 'plugin_file',
    render: t => (
      <a target="_blank" href={t}>
        {t.split('/').slice(-1)[0]}
      </a>
    ),
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: 80,
    key: 'status',
    render: t => (
      <div className={s.statusBadge}>
        <Badge
          status={t === 'on' ? 'processing' : 'default'}
          text={t === 'on' ? '启用' : '停用'}
        />
      </div>
    ),
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
    key: 'create_time',
    width: 190,
  },
  {
    title: '最后更新时间',
    dataIndex: 'update_time',
    key: 'update_time',
    width: 190,
  },
  {
    title: '操作',
    dataIndex: 'x',
    key: 'x',
    width: 160,
    render: (t, item) => (
      <div>
        <a
          onClick={() => {
            self.setModals({
              key: 'updateForm',
              title: '编辑敏感词',
              item,
              visible: true,
            });
          }}
        >
          编辑
        </a>
        <Divider type="vertical" />
        <Popconfirm
          title="确认删除？"
          placement="left"
          okText="确认"
          cancelText="取消"
          onConfirm={() => self.deleteItem(item.id)}
        >
          <a>删除</a>
        </Popconfirm>
      </div>
    ),
  },
];
